import { tv } from 'tailwind-variants';

export const modalVariants = tv({
  slots: {
    overlay: [
      'fixed',
      'inset-0',
      'bg-black/70',
      'z-50',
      'flex',
      'flex-col',
      'justify-center',
      'items-center',
      'p-[16px]',
    ],
    modal: [
      'bg-white',
      'rounded-lg',
      'shadow-2xl',
      'w-full',
      'relative',
      'outline-none',
      'zoom-in-95',
      'slide-in-from-bottom-4',
      'duration-200',
      'max-h-[90vh]',
      'flex',
      'flex-col',
      'py-6',
    ],
    closeButton: [
      'absolute',
      'top-1 md:top-[16px]',
      'right-1 md:right-4',
      'z-10',
      'p-2',
      'rounded-md',
      'hover:bg-gray-100',
      'focus:outline-none',
      'focus:ring-2',
      'focus:ring-blue-500',
      'focus:ring-offset-2',
      'transition-colors',
      'duration-200',
    ],
    modalContent: ['p-6', 'overflow-y-auto', 'flex-1', 'min-h-0'],
  },
  variants: {
    size: {
      sm: { modal: ['md:max-w-md'] },
      md: { modal: ['md:max-w-2xl'] },
      lg: { modal: ['md:max-w-4xl'] },
      xl: { modal: ['md:max-w-6xl'] },
      full: { modal: ['md:max-w-[95vw]'] },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
